import { ScreenDetailed } from '../types';

export async function detectExternalScreen(): Promise<ScreenDetailed | null> {
  if (!window.getScreenDetails) return null;

  try {
    // getScreenDetails() will trigger the permission prompt if needed
    const screenDetails = await window.getScreenDetails();
    if (!screenDetails) return null;
    
    return screenDetails.screens.find((screen: ScreenDetailed) => !screen.isPrimary) || null;
  } catch (error) {
    // Handle permission denied or other errors
    console.error('Failed to get screen details:', error);
    return null;
  }
}
  